import { useLocaleFilter } from "@common/hooks/useLocaleFilter";
import { checkLocales } from "@common/utils/locales";
import { reduxWrapper } from "@common/redux/store";
import { IframeEvents } from "@kursk/components/pages/IframeEvents/IframeEvents";
import { api } from "@common/urls";
import axios from "axios";
import moment from "moment";

export default function EventsPage({ items, total, params }) {
  useLocaleFilter();

  return <IframeEvents items={items} total={total} params={params}/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async (
  { store, query, res, req, params, ...data }
) => {
  const checkResult = await checkLocales(data['resolvedUrl'], query, req, res, store);
  if (checkResult) return checkResult;

  const requestParams = {
    start: moment().startOf('day').valueOf(),
    sort: 'actual.start',
    organizationSysName: params.organizationSysName,
    withTickets: true,
    etype: 'event,movie',
    limit: 12
  }
  const eventsResponse = await axios.get(
    api.events.get(),
    {
      params: {
        ...requestParams,
        offset: 0,
      }
    }
  );

  return { props: { items: eventsResponse.data.events, total: eventsResponse.data.total, params: requestParams } };
})
